import { useRef } from 'react';
import Carousel1 from '../../Assets/carousel_1.png';
import Carousel2 from '../../Assets/carousel_2.png';
import Carousel3 from '../../Assets/carousel_3.png';
import Carousel4 from '../../Assets/carousel_4.png';
import Carousel5 from '../../Assets/carousel_5.png';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import * as S from './style';

export const Sectors = () => {
  const swiperRef = useRef(null);

  const cards = [
    {
      title: "Energia",
      description: "Estações de distribuição, usinas, linhas de transmissão, transformadores, torres de alta tensão.",
      img: Carousel1,
    },
    {
      title: "Telecom",
      description: "Torres de sinal, antenas, data centers, infra de campo, painéis de controle e cabeamento de rede.",
      img: Carousel2,
    },
    {
      title: "Indústrias",
      description: "Máquinas críticas, linhas de produção, painéis elétricos, compressores, motores, caldeiras.",
      img: Carousel3,
    },
    {
      title: "Óleo & Gás",
      description: "Oleodutos, válvulas, plataformas, bombas de extração, tanques de armazenamento, sensores de pressão.",
      img: Carousel4,
    },
    {
      title: "Infra Estrutura Urbana",
      description: "Pontes, viadutos, passarelas, túneis, estruturas metálicas e de concreto armado.",
      img: Carousel5,
    },
  ];

  return (
    <div style={{
      position: 'relative'
    }}>
      <S.Content
        id="sectors"
        style={{
          width: '100%',
          position: 'relative',
          overflowX: 'hidden'
        }}
      >

        <S.Wrapper>
          <S.TextBox>
            <S.Title>
              Tecnologia preditiva onde a operação exige precisão.
            </S.Title>
            <S.Text>
              Atue com segurança, rastreabilidade e resposta rápida no campo, na torre ou na fábrica.
            </S.Text>

            <S.CrouselBtnBox>
              <S.CrouselBtn onClick={() => swiperRef.current?.slidePrev()}>
                <SlArrowLeft />
              </S.CrouselBtn>
              <S.CrouselBtn onClick={() => swiperRef.current?.slideNext()}>
                <SlArrowRight />
              </S.CrouselBtn>
            </S.CrouselBtnBox>
          </S.TextBox>

          <S.CarouselBox>
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              modules={[Navigation]}
              slidesPerView="auto"
              spaceBetween={16}
              slidesPerGroup={1}
              style={{ padding: 0 }}
              loop={true}
            >
              {cards.map((card, index) => (
                <SwiperSlide key={index} className="swiper-slide-custom">
                  <S.Card>
                    <img src={card.img} alt={card.title} />
                    <div>
                      <h3>{card.title}</h3>
                      <p>{card.description}</p>
                    </div>
                  </S.Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </S.CarouselBox>
        </S.Wrapper>
      </S.Content>
    </div>
  );
};
